import { isThemePreference, type ThemePreference } from "./types";

/**
 * Per-device preference. Kept in localStorage (not the profile) so it applies
 * before login and needs no backend. The inline anti-flash script in
 * index.html reads the same key; keep them in sync.
 */
export const THEME_STORAGE_KEY = "caseblink.theme";

/** Existing users keep the light UI until they opt in. */
export const DEFAULT_THEME_PREFERENCE: ThemePreference = "light";

const storage = (): Storage | null => {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    // Access can throw under strict privacy settings.
    return null;
  }
};

export function readThemePreference(): ThemePreference {
  try {
    const raw = storage()?.getItem(THEME_STORAGE_KEY);
    return isThemePreference(raw) ? raw : DEFAULT_THEME_PREFERENCE;
  } catch {
    return DEFAULT_THEME_PREFERENCE;
  }
}

export function writeThemePreference(preference: ThemePreference): void {
  try {
    storage()?.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    // Quota / privacy mode: the in-memory preference still applies for the session.
  }
}
